module.exports = require("https");


/*****************
 ** WEBPACK FOOTER
 ** external "https"
 ** module id = 4
 ** module chunks = 0
 **/